
import Loading from '@/components/common/Loading'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import SchemaTags from "@/components/common/SchemaTags";
import React from 'react'



const Desktop = dynamic(() => import("@/components/outlet/LuggageStore"), {
  loading: () => <Loading />
})

const Mobile = dynamic(() => import("@/components/outlet/LuggageStoreMobile"), {
  loading: () => <Loading />
})


const luggagestore = ({mobileView}) => {
    return(
        <>
        <Head>
                <title> Luggage Store | POS System for Luggage Store</title>
                <link rel="canonical" href="https://queuebuster.co/outlet/luggage-store-pos-billing-software" />
                <link rel="alternate" href="https://queuebuster.co/outlet/luggage-store-pos-billing-software" hrefLang="en" />
                <meta name="description" content="Streamline your luggage store operations with QueueBuster’s POS Billing Software. Easily manage inventory and billing of luggage—all in one pos." />
                <meta property="og:title" content="Make Every Luggage Purchase Seamless with QueueBuster’s Luggage Store POS" />
                <meta property="og:description" content="Manage your luggage store like a pro! QueueBuster’s POS Billing Software simplifies billing, tracks inventory, and keeps your store running in perfect order." />
                <meta property="og:image" content="" />
                <meta property="og:url" content="https://queuebuster.co/outlet/luggage-store-pos-billing-software" />
            </Head>
         <SchemaTags page="luggage-store-pos-billing-software" />
          {mobileView ?  <Mobile/>: <Desktop/>}
        </>
    )
}



export default luggagestore